import BenefitsLabels from './benefits-labels'

export default BenefitsLabels
